import { render, staticRenderFns } from "./ESGScopeWiseDetails.vue?vue&type=template&id=9f1e4f1a"
import script from "./ESGScopeWiseDetails.vue?vue&type=script&lang=js"
export * from "./ESGScopeWiseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports